import { ChangeEvent, useEffect, useState } from 'react';
import * as imageConversion from 'image-conversion';

export const useEditableAvatar = ({ data }: any) => {
    const [show, setShow] = useState(false);
    const currentAvatar = data?.avatar?.avatar ?? null;
    const [imageData, setImageData] = useState<string | null>(currentAvatar);

    async function convertToWebP(file: File): Promise<string> {
        let dataUrl = '';

        await imageConversion
            .compressAccurately(file, {
                format: 'webp',
                size: 100,
                quality: 0.7, // Adjust the quality as needed
            })
            .then(async (res) => {
                dataUrl = await imageConversion.filetoDataURL(res);
            });
        return dataUrl;
    }

    useEffect(() => {
        if (!show) {
            setImageData(currentAvatar);
        }
    }, [currentAvatar, show]);

    const handleClose = () => {
        setShow(false);
    };
    const handleOpen = () => {
        setImageData(currentAvatar);
        setShow(true);
    };
    const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];

        if (file) {
            convertToWebP(file)
                .then((compressedDataUrl) => {
                    setImageData(compressedDataUrl);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        event.target.value = '';
    };

    const resetAvatarPhoto = () => {
        setImageData(null);
    };

    return {
        models: { show, imageData, currentAvatar, hasChanges: currentAvatar !== imageData },
        operations: {
            handleImageUpload,
            handleOpen,
            handleClose,
            resetAvatarPhoto,
        },
    };
};
